import styled from 'styled-components'

import { Flex } from './Flex'

type IProgressBar = {
  labelStart?: string
  labelEnd?: string
  percent: number
}
const Wrapper = styled.div`
  margin: 5px 0 12px;
  width: 100%;

  .labels {
    font-size: 0.85rem;
  }
`

const BarWrapper = styled.div`
  background: #deebf7;
  border-radius: 6px;
`

const BarStatus = styled.div<{ width: string }>`
  height: 12px;
  width: ${(props) => (props.width ? `${props.width}%` : '0%')};
  background: ${(props) => props.theme.primaryColor};
  transition: all 200ms;
  border-radius: 6px;
`

export function ProgressBar({ percent, labelStart, labelEnd }: IProgressBar) {
  return (
    <Wrapper>
      <BarWrapper>
        <BarStatus width={isNaN(percent) ? '0' : percent.toString()} />
      </BarWrapper>
      {labelStart || labelEnd ? (
        <Flex
          className="labels"
          alignitems="center"
          justifycontent="space-between"
          direction="row-reverse"
        >
          <span>{labelEnd}</span>
          <span>{labelStart}</span>
        </Flex>
      ) : (
        ''
      )}
    </Wrapper>
  )
}
